import { render, staticRenderFns } from "./ChartTitle.vue?vue&type=template&id=2a122238&scoped=true"
import script from "./ChartTitle.vue?vue&type=script&lang=js"
export * from "./ChartTitle.vue?vue&type=script&lang=js"
import style0 from "./ChartTitle.vue?vue&type=style&index=0&id=2a122238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a122238",
  null
  
)

export default component.exports